import "./footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-left">
          <h3>Prof. Dr. K. M. Diwakarrao</h3>
          <p>Academic Portfolio</p>
        </div>

        {/* CENTER LINKS */}
        <div className="footer-links">

          <Link to="/">Home</Link>

          <Link to="/gallery">Gallery</Link>

          <Link to="/blogs">Blogs</Link>

          <Link to="/#contact">Contact</Link>

          <Link to="/privacy">Privacy Policy</Link>

        </div>

        {/* RIGHT */}
        <div className="footer-right">
          <p>© 2024 SYTEOS LABS LLP.</p>

          <p className="powered">
            Powered by{" "}
            <a
              href="https://syteoslabs.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Syteos Labs LLP
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
}